import { Col, Row } from 'antd';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { approveRejectShipmentInProgress } from '../../../redux/auth/AuthActions';
import { routeFileSelector } from '../../../utilz/i18n';
import FilterCard from '../../components/Cards/FilterCard';
import PrimaryLabel from '../../components/Labels/PrimaryLabel';
import SecondaryLabel from '../../components/Labels/SecondaryLabel';
import ContentSpinner from '../../components/Spinners/ContentSpinner';

const ShipmentApproveRejectPage = () => {
  const dispatch = useDispatch();
  const { approveRejectShipment } = useSelector((state) => state.auth);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const [searchParams] = useSearchParams();
  const actionUrl = useMemo(() => searchParams.get('url'), [searchParams]);

  useEffect(() => {
    if (actionUrl) {
      dispatch(approveRejectShipmentInProgress({ url: actionUrl }));
    }
  }, [actionUrl]);

  return (
    <Row className="h-100 w-100 overflow-hidden " justify="center" align="middle">
      <Col className="w-70" style={{ maxHeight: '70%', overflow: 'hidden' }}>
        <FilterCard
          className="h-100 overflow-hidden d-flex flex-direction-column background-white"
          headerClassName="background-header border-none"
          customHeader={
            <div className="w-100 text-center">
              <PrimaryLabel className="text-white">
                {t('translation:default.fields.approvalRejectionMessage')}
              </PrimaryLabel>
            </div>
          }
        >
          <div className="p-50 flex-1 custom-scroll-bar">
            <Row justify="center" align="middle">
              <Col>
                {!actionUrl ? (
                  <SecondaryLabel className="text-danger fw-600 f-16">
                    {t('translation:default.fields.redirectURL')}
                  </SecondaryLabel>
                ) : (
                  <>
                    {approveRejectShipment?.progressing ? (
                      <>
                        <ContentSpinner />
                        <br />
                        <SecondaryLabel className="text-primary fw-600 f-16">
                          {t('translation:default.fields.validatingPleaseWait')}
                        </SecondaryLabel>
                      </>
                    ) : (
                      <SecondaryLabel className="text-danger fw-600 f-16">
                        {approveRejectShipment?.message}
                      </SecondaryLabel>
                    )}
                  </>
                )}
              </Col>
            </Row>
          </div>
        </FilterCard>
      </Col>
    </Row>
  );
};

export default ShipmentApproveRejectPage;
